import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    users_organizations_table: {
      content: {
        pagination: {
          'rowsPerPage': 10,
          'sortBy'     : 'name'[1],
        },
        headers: [
          {text: 'id', value: 'id'},
          {text: 'Название', value: 'name'},
          // {text: 'Группа организаций', value: 'group'},
          {text: 'Уровень', value: 'level'},
          {text: 'Тип организации', value: 'type'},
          // {text: 'Управление', value: 'department'},
          {text: 'Дата добавления', value: 'date'},
        ],
        body: [],
      },
    },
    search_string    : '',
    group_filter     : '',
    type_filter      : '',
    department_filter: '',
    showed_filter    : false,
    org_pages        : 0,
    page             : 1,
    org_filters      : {
      groups     : '',
      departments: '',
      types      : '',
    },
  },
  getters: {
    page                     : ({page}) => page,
    org_pages                : ({org_pages}) => org_pages,
    search_string            : ({search_string}) => search_string,
    org_filters              : ({org_filters}) => org_filters,
    showed_filter            : ({showed_filter}) => showed_filter,
    group_filter             : ({group_filter}) => group_filter,
    type_filter              : ({type_filter}) => type_filter,
    department_filter        : ({department_filter}) => department_filter,
    users_organizations_table: ({users_organizations_table}) => {
      const pagination = localStorage.getItem('paginationValueOrganization') || 10;
      users_organizations_table.content.pagination.rowsPerPage = pagination;
      return users_organizations_table;
    },
  },
  mutations: {
    TOGGLE_FILTER(state) {
      state.showed_filter = !state.showed_filter;
    },
    RESET_ORG_FILTERES(state) {
      state.group_filter = '';
      state.department_filter = '';
      state.type_filter = '';
      state.users_organizations_table.content.pagination.sortBy = '';
      state.users_organizations_table.content.pagination.descending = '';
    },
    SET_ORGANIZATION_PAGINATION(state, value) {
      let selectedTable = state.users_organizations_table.content;
      selectedTable.pagination = value;
    },
    SHOW_NUMBER(state, selected) {
      let selectedTable = state.users_organizations_table.content;

      if (selected=='Показывать по 10') {
        selectedTable.pagination.rowsPerPage = 10;
      } else if (selected=='Показывать по 25') {
        selectedTable.pagination.rowsPerPage = 25;
      } else if (selected=='Показывать по 50') {
        selectedTable.pagination.rowsPerPage = 50;
      } else if (selected=='Показывать по 100') {
        selectedTable.pagination.rowsPerPage = 100;
      }
    },
    SET_PAGE(state, value) {
      state.page = value;
    },
    SET_PAGES_COUNT(state, value) {
      state.org_pages = value;
    },
    SEARCH_ORGANIZATION(state, value) {
      state.search_string = value;
    },
    CHANGE_ORGANIZATION_SORT(state, column) {
      let selectedTable = state.users_organizations_table.content;
      if (selectedTable.pagination.sortBy === column) {
        selectedTable.pagination.descending = !selectedTable.pagination.descending;
      } else {
        selectedTable.pagination.sortBy = column;
        selectedTable.pagination.descending = false;
      }
    },
    SET_GROUP_FILTER(state, value) {
      state.group_filter = value;
    },
    SET_TYPE_FILTER(state, value) {
      state.type_filter = value;
    },
    SET_DEPARTMENT_FILTER(state, value) {
      state.department_filter = value;
    },
    ADD_ORG(state, org) {
      state.users_organizations_table.content.body.push(org);
    },
    SET_COMPANIES(state, value) {
      if (value) {
        value.forEach((item, idx) => {
          for (let key in item) {
            if (key == 'group' || key == 'department') {
              delete item[key];
            }
          }
        });

        state.users_organizations_table.content.body = value;
      } else {
        state.users_organizations_table.content.body = [];
      }
    },
    SET_ORG_FILTERS(state, value) {
      state.org_filters = value;
    },
  },
  actions: {
    async update_table({state, dispatch, rootGetters}) {
      let page_size = localStorage.getItem('paginationValueOrganization') || 50;
      let page_num   = state.users_organizations_table.content.pagination.page;
      let group    = rootGetters['users/organizations/group_filter'];
      let spec     = state.type_filter;
      let llk      = state.department_filter;
      let name     = state.users_organizations_table.content.search;

      let obj = {llk, page_size, page_num, group, spec, name};

      await dispatch('get_companies', obj);
    },
    async accept_new_org({commit, rootGetters}, org) {
      let request_id = rootGetters['users/requests/request_id'];
      let org_id = org.id ? org.id : request_id;
      let new_org = {
        id    : org.id,
        active: true,
        name  : [org.logo, org.name],
        type  : org.type,
        date  : new Date().getTime(),
      };
      try {
        await api.company.company_activate(org_id);
        commit('users/modals/CLOSE_MODAL', 'accept_request', {root: true});
        commit('ADD_ORG', new_org);
        commit('users/requests/REMOVE_REQUEST', {request: org_id, type: 'org'}, {root: true});
      } catch (err) {
        console.error(err);
      }
    },
    async decline_new_org({commit}, org) {
      let new_org = {
        id        : org.id,
        active    : org.active,
        name      : [org.logo, org.name],
        group     : org.group,
        type      : org.type,
        department: org.department,
        date      : org.date,
      };
      try {
        await api.company.decline_user(org.id);
        commit('users/modals/CLOSE_MODAL', 'accept_request', {root: true});
        commit('users/requests/REMOVE_REQUEST', {request: new_org.id, type: 'org'}, {root: true});
      } catch (err) {
        console.error(err);
      }
    },
    async get_companies({state, commit}, obj) {
      let sortBy = state.users_organizations_table.content.pagination.sortBy;
      let sortOrder = state.users_organizations_table.content.pagination.descending ? 'desc' : 'asc';
      try {
        let companies = await api.company.get_companies(obj.page_size, obj.page_num, obj.group, obj.spec, obj.llk, obj.name, sortBy, sortOrder);
        let get_filters = await api.company.get_companies_filters();
        commit('SET_COMPANIES', companies.data.content);
        commit('SET_PAGES_COUNT', companies.data.page_count);
        commit('SET_ORG_FILTERS', get_filters.data);
      } catch (err) {
        console.error(err);
      }
    },
    async add_new_org({commit}, obj) {
      try {
        let add_org = await api.company.add_company(obj);
        commit('users/requests/SET_REQUEST_ID', add_org.data.id, {root: true});
      } catch (err) {
        console.error(err);
      }
    },

  },
};
